import { Form } from 'informed';
import PropTypes from 'prop-types';

import { HeadingLevel } from 'lib/customPropTypes';

import { HX } from '../Headings';

import FilterReset from './FilterReset';

//
// NOTE: This component is rather complex and could be simplified.
//       Suggest investigating the use of a JSON data payload.
//       Instead of forcing the developer to know about child component requirements
//       – such as FilterCategory, FilterItem, and CustomCheckbox.
//
const Filter = ({
  ariaControls,
  children,
  heading,
  headingLevel,
  headingLevelStyle,
  onChange,
  resetLabel,
}) => {
  return (
    <nav aria-controls={ariaControls}>
      <Form onValueChange={onChange}>
        {heading.length && (
          <div className="flex items-center justify-between mb-6">
            <HX
              className="mb-0"
              level={headingLevel}
              levelStyle={headingLevelStyle}
            >
              {heading}
            </HX>
            <FilterReset onReset={onChange}>{resetLabel}</FilterReset>
          </div>
        )}
        {children}
      </Form>
    </nav>
  );
};

Filter.defaultProps = {
  heading: '',
  headingLevel: 3,
  headingLevelStyle: 4,
};

Filter.propTypes = {
  ariaControls: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  heading: PropTypes.string,
  headingLevel: HeadingLevel,
  headingLevelStyle: HeadingLevel,
  onChange: PropTypes.func.isRequired,
  resetLabel: PropTypes.string.isRequired,
};

export default Filter;
